export default function DataSourceBadge({ isReal, dataSource }) {
  if (isReal) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#E6F9ED', color: '#007A33', border: '1px solid #A5D6A7', fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 99, letterSpacing: '0.03em' }}>
        <span style={{ width: 6, height: 6, background: '#00C853', borderRadius: '50%', display: 'inline-block' }}></span>
        LIVE DATA • {dataSource || 'DataForSEO'}
      </span>
    );
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#FFF8E1', color: '#8B5E00', border: '1px solid #FFE082', fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 99 }}>
      <span style={{ width: 6, height: 6, background: '#FFAB00', borderRadius: '50%', display: 'inline-block' }}></span>
      DEMO DATA • Add API keys for real
    </span>
  );
}
